'use client';

import { useSyncExternalStore } from 'react';
import { ArrowUpRight, Monitor, Smartphone } from 'lucide-react';
import { detectStorePlatform, type StorePlatform } from './platform';

const stores: { platform: StorePlatform; name: string; store: string; url: string }[] = [
  { platform: 'android', name: 'Android', store: 'Google Play', url: 'https://play.google.com/store/apps/details?id=com.pteultra.app' },
  { platform: 'ios', name: 'iPhone / iPad', store: 'App Store', url: 'https://apps.apple.com/app/id6774854439' },
  { platform: 'windows', name: 'Windows', store: 'Microsoft Store', url: 'https://apps.microsoft.com/detail/9PLPZTT28L3X' },
  { platform: 'macos', name: 'macOS', store: 'Mac App Store', url: 'https://apps.apple.com/app/id6774854439' },
];

const subscribe = () => () => {};
const serverSnapshot = () => null;
const browserSnapshot = () => detectStorePlatform(navigator.userAgent, navigator.platform, navigator.maxTouchPoints);

export default function StoreButtons() {
  const recommended = useSyncExternalStore(subscribe, browserSnapshot, serverSnapshot);

  return (
    <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
      {stores.map(({ platform, name, store, url }) => {
        const Icon = platform === 'android' || platform === 'ios' ? Smartphone : Monitor;
        return (
          <a key={platform} href={url} aria-label={`Update PTE Ultra for ${name} on ${store}`}
            data-recommended={recommended === platform ? 'true' : undefined}
            className="group flex flex-col rounded-3xl border border-border bg-card p-6 text-card-foreground shadow-sm transition hover:border-secondary hover:shadow-md data-[recommended=true]:border-secondary data-[recommended=true]:bg-secondary/5 focus-visible:outline-4 focus-visible:outline-offset-4 focus-visible:outline-secondary">
            <span className="flex min-h-10 items-start justify-between gap-2 text-xs font-bold text-secondary">
              <Icon aria-hidden="true" className="size-8 shrink-0" />
              {recommended === platform && <span className="max-w-36 rounded-full bg-secondary px-3 py-1 text-center text-secondary-foreground">Recommended for your device</span>}
            </span>
            <h3 className="mt-5 text-2xl font-extrabold">{name}</h3>
            <p className="mb-6 mt-1 text-sm text-muted-foreground">{store}</p>
            <span className="mt-auto flex min-h-12 items-center justify-center gap-2 rounded-xl border border-border px-2 py-3 text-center text-sm font-bold group-data-[recommended=true]:border-secondary group-data-[recommended=true]:bg-secondary group-data-[recommended=true]:text-secondary-foreground">
              Open {store}<ArrowUpRight aria-hidden="true" className="size-4" />
            </span>
          </a>
        );
      })}
    </div>
  );
}
